import { create } from 'zustand';
import { api } from '../lib/api';
import type { Edition, FeatureKey, EditionInfoDto } from '@pokerroom/types';

interface EditionState {
  edition: Edition;
  enabledFeatures: FeatureKey[];
  isLoaded: boolean;
  isTrialActive: boolean;
  trialDaysRemaining: number | null;

  fetchEditionInfo: () => Promise<void>;
  hasFeature: (feature: FeatureKey) => boolean;
  isLite: () => boolean;
}

export const useEditionStore = create<EditionState>((set, get) => ({
  edition: 'business' as Edition,
  enabledFeatures: [],
  isLoaded: false,
  isTrialActive: false,
  trialDaysRemaining: null,

  fetchEditionInfo: async () => {
    try {
      const data = await api.get<EditionInfoDto>('/auth/edition-info');
      set({
        edition: data.edition,
        enabledFeatures: data.enabledFeatures,
        isLoaded: true,
        isTrialActive: data.isTrialActive ?? false,
        trialDaysRemaining: data.trialDaysRemaining ?? null,
      });
    } catch (err) {
      console.warn('[EditionStore] Failed to fetch edition info:', err);
      // Only fall back to empty if never loaded; preserve existing features on transient errors (e.g. 401 refresh)
      if (!get().isLoaded) {
        set({
          edition: 'lite' as Edition,
          enabledFeatures: [],
          isLoaded: true,
          isTrialActive: false,
          trialDaysRemaining: null,
        });
      }
    }
  },

  hasFeature: (feature: FeatureKey) => {
    return get().enabledFeatures.includes(feature);
  },

  isLite: () => get().edition === ('lite' as Edition),
}));
